import {Component, Injector, OnInit} from "@angular/core";
import {
	BasicMaterialDialog,
	MatDialogDataBaseInput,
	MatDialogDataBaseOutput,
} from "../../basic-material-dialog/basic-material-dialog.directive";
import {TranslateService} from "@ngx-translate/core";
import {Router} from "@angular/router";
import {CanRecordResponse, CanRecordResult, RecData} from "@models";
import {environment} from "../../../../../../environments/environment";
import {NotificationService, SimRecorderService} from "@services";
import {Translations} from "@translations";

export interface DialogData_CanRecordBlockedDialog extends MatDialogDataBaseInput {
	canRecord: CanRecordResponse;
}

export interface DialogData_CanRecordBlockedDialogOutput extends MatDialogDataBaseOutput {
	result: CanRecordResult;
}

@Component({
	selector: "sim-can-record-blocked-dialog",
	templateUrl: "./can-record-blocked-dialog.component.html",
	styleUrls: ["./can-record-blocked-dialog.component.scss"],
	standalone: false,
})
export class CanRecordBlockedDialogComponent
	extends BasicMaterialDialog<CanRecordBlockedDialogComponent, DialogData_CanRecordBlockedDialog, DialogData_CanRecordBlockedDialogOutput>
	implements OnInit
{
	T = Translations;

	CanRecordResult = CanRecordResult;

	constructor(
		_injector: Injector,
		private translate: TranslateService,
		private router: Router,
		private simRecorderService: SimRecorderService,
		private simNotificationService: NotificationService,
	) {
		super(_injector);
	}

	ngOnInit(): void {
		super.ngOnInit();
	}

	async navigateToDashboard() {
		await this.router.navigate([environment.routes.eventDashboard]);
		this.close({action: "ok", result: this.data.canRecord.result});
	}

	async stopOldRecordingAndProceed() {
		const stopRecordingResult = await this.simRecorderService.stopRecording({
			trainingSessionId: this.data.canRecord.additionalData?.runningRecording?.teamTrainingSession?.id,
		});

		if (!stopRecordingResult.success) {
			window.location.reload();
			console.warn(stopRecordingResult.reason);
			//this.simNotificationService.notifyError(stopRecordingResult.reason);
		} else {
			this.data.canRecord.result = CanRecordResult.Ok;
			this.close({action: "ok", result: this.data.canRecord.result});
		}
	}

	async navigateToOldRecording() {
		await this.navigateToRecording(this.data.canRecord.additionalData?.runningRecording);
	}

	private async navigateToRecording(data: RecData) {
		await this.router.navigate([environment.routes.simrecorder, "default", data.teamTrainingSession?.id]);
		this.close({action: "ok", result: this.data.canRecord.result});
	}

	getDialogTitle() {
		switch (this.data?.canRecord?.result) {
			case CanRecordResult.RecorderHasOtherActiveRecording:
				return this.translate.instant(this.T.CAN_RECORD_RECORDERHASOTHERACTIVERECORDING_TITLE);
			case CanRecordResult.RecordingHasOtherActiveRecorder:
				return this.translate.instant(this.T.CAN_RECORD_RECORDINGHASOTHERACTIVERECORDER_TITLE);
			case CanRecordResult.RecordingIsPreparedByOtherActiveRecorder:
				return this.translate.instant(this.T.CAN_RECORD_RECORDINGISPREPAREDBYOTHERACTIVERECORDER_TITLE);
			default:
				return "";
		}
	}
}
